var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetCoin = function SvgZetCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zetCoin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB7E",
    d: "M8 .92a7.08 7.08 0 1 0 0 14.16A7.08 7.08 0 0 0 8 .92"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetCoin_svg__b)",
    d: "M8 1.835a6.166 6.166 0 1 0 0 12.331A6.166 6.166 0 0 0 8 1.835"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C4710",
    fillRule: "evenodd",
    d: "M6.577 6.15H3.315v1.14h1.573L3.315 8.711v1.14h3.262v-1.14H5.004l1.573-1.423zm6.107 0h-4.04l.52 1.14h1.195V9.85h1.14V7.29h1.185zM7.882 8.711h1.663l.53 1.14H6.838V6.148h1.517l.52 1.14h-.993v.196h1.094l.18.39.297.64h-1.57z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "zetCoin_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(133.506 2.277 5.674)scale(9.62612)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FFC774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D58F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58F26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zetCoin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgZetCoin;